import React, { useEffect, useRef } from 'react';
import { StarIcon } from 'lucide-react';
export const TrustpilotReviews = () => {
  const trustboxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  return <section className="mb-12" data-id="element-419">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-420">
        Wat cursisten over ons zeggen
      </h2>
      <div ref={trustboxRef} className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-id="element-421">
        <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-422">
          Trustpilot
        </a>
      </div>
    </section>;
};